// extracted by mini-css-extract-plugin
export default {"container":"ServiceDataTab_container__LxicQ","block":"ServiceDataTab_block__2UopT","serviceData":"ServiceDataTab_serviceData__N2zun"};